// extracted by mini-css-extract-plugin
module.exports = {"addActivity":"home_addActivity__2JOZM","navContainer":"home_navContainer__1K0Am"};